import React from 'react';
import RawHTML from '~/components/jsx-helpers/raw-html';
import useOptimizedImage from '~/helpers/use-optimized-image';
import './about.scss';
export default function About({ heading, description, altText, image: { meta: { downloadUrl: image } } }) {
    const optimizedImage = useOptimizedImage(image);
    return (React.createElement("section", { className: "about near-white" },
        React.createElement("div", { className: "content-block" },
            React.createElement("div", { className: "text-block" },
                React.createElement("h2", null, heading),
                React.createElement(RawHTML, { className: "description-block", html: description })),
            React.createElement("img", { src: optimizedImage, alt: altText }))));
}
